import { render, staticRenderFns } from "./SettingsAMLKYT.vue?vue&type=template&id=092dcb68&scoped=true&"
import script from "./SettingsAMLKYT.vue?vue&type=script&lang=js&"
export * from "./SettingsAMLKYT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092dcb68",
  null
  
)

export default component.exports